import { render, staticRenderFns } from "./priceListAdminAudit.vue?vue&type=template&id=fa5cb02c&scoped=true"
import script from "./priceListAdminAudit.vue?vue&type=script&lang=js"
export * from "./priceListAdminAudit.vue?vue&type=script&lang=js"
import style0 from "./priceListAdminAudit.vue?vue&type=style&index=0&id=fa5cb02c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5cb02c",
  null
  
)

export default component.exports